import React from "react";
import Link from "next/link";
import { ZendeskAPI } from "react-zendesk";

export default function ProductChat() {
  const handleChat = () => {
    ZendeskAPI("webWidget", "show")
    ZendeskAPI("webWidget", "open")

    ZendeskAPI("webWidget:on", "close", function() {
      ZendeskAPI("webWidget", "hide")
    });
  };
  return (
    <div className="support-box">
      <div onClick={handleChat} className="chat">
        Live Chat
      </div>
      <Link href="/contact">
        <a className="contact-us">Contact Us</a>
      </Link>
    </div>
  );
}
